export const ROULETTE_LAST_RESULT_DELAY_FOR_GUI = 1500; // ms
